import { useFormContext } from 'react-hook-form'

import { FormError, SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface InstrumentTypeIdFormFieldProps {
  instrumentTypes?: { label: string; value: number }[]
  loading?: boolean
}

export const InstrumentTypeIdFormField: React.FC<InstrumentTypeIdFormFieldProps> = ({
  instrumentTypes,
  loading,
}) => {
  const { control, setValue } = useFormContext<{ instrument_type_id: number }>()

  return (
    <FormField
      name="instrument_type_id"
      control={control}
      render={({ field }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Product Type</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              loading={loading}
              className={'min-w-full'}
              value={field.value?.toString()}
              options={instrumentTypes?.map((o) => ({
                label: o.label,
                value: o.value?.toString(),
              }))}
              setValue={(val) => {
                setValue('instrument_type_id', parseInt(val), { shouldValidate: true })
              }}
              placeholder={'Select a Product'}
            />
          </FormItem>
        )
      }}
    />
  )
}
